var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_29214",
    "data-name": "Group 29214",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96.001,
    viewBox: "0 0 96 96.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26955",
    "data-name": "Group 26955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32574",
    "data-name": "Path 32574",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(8 8)",
    fill: "#4b74f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32574_-_Outline",
    "data-name": "Path 32574 - Outline",
    d: "M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0m0-8A48,48,0,1,1-8,40,48.055,48.055,0,0,1,40-8Z",
    transform: "translate(8 8)",
    fill: "rgba(75,116,244,0.3)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-down-solid",
    d: "M31.955,45.79l1.433,1.433a1.543,1.543,0,0,1,0,2.189L20.844,61.963a1.543,1.543,0,0,1-2.189,0L6.105,49.412a1.543,1.543,0,0,1,0-2.189L7.538,45.79a1.551,1.551,0,0,1,2.214.026l7.412,7.78V26.833a1.546,1.546,0,0,1,1.549-1.549H20.78a1.546,1.546,0,0,1,1.549,1.549V53.6l7.412-7.78a1.54,1.54,0,0,1,2.214-.026Z",
    transform: "translate(67.746 91.852) rotate(180)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.86340fc3431bee0e75aab6ae91b6e17d.svg";
export { ForwardRef as ReactComponent };